import { useCallback, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useSocket } from "../context/SocketContext";
import TicketExtendedModal from "../compoment/modals/TicketExtendedModal";
import {
  clearTicketDetailFromStorage,
  getPaymentSubscriptionUserId,
} from "../utils/ticket";

const TICKET_EXTENDED_REDIRECT_MS = 3_000;

const KioskSessionManager = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { paymentSocket, paymentConnected } = useSocket();
  const [showTicketExtendedModal, setShowTicketExtendedModal] = useState(false);
  const ticketExtendedTimerRef = useRef<ReturnType<typeof setTimeout> | null>(
    null
  );
  const ticketExtendedHandledRef = useRef(false);

  const clearTicketExtendedTimer = useCallback(() => {
    if (ticketExtendedTimerRef.current) {
      clearTimeout(ticketExtendedTimerRef.current);
      ticketExtendedTimerRef.current = null;
    }
  }, []);

  const handleTicketExtended = useCallback(() => {
    if (ticketExtendedHandledRef.current) return;
    ticketExtendedHandledRef.current = true;

    setShowTicketExtendedModal(true);
    clearTicketExtendedTimer();

    ticketExtendedTimerRef.current = setTimeout(() => {
      setShowTicketExtendedModal(false);
      ticketExtendedHandledRef.current = false;
      clearTicketDetailFromStorage();
      navigate("/", { replace: true });
    }, TICKET_EXTENDED_REDIRECT_MS);
  }, [clearTicketExtendedTimer, navigate]);

  useEffect(() => {
    if (!paymentSocket || !paymentConnected) return;

    const userId = getPaymentSubscriptionUserId();
    if (!userId) return;

    paymentSocket.emit("subscribeToPaymentStatus", { userId });

    const onTicketTimeUpdated = () => {
      handleTicketExtended();
    };

    const onPaymentStatusUpdate = () => {
      handleTicketExtended();
    };

    paymentSocket.on("ticketTimeUpdated", onTicketTimeUpdated);
    paymentSocket.on("paymentStatusUpdate", onPaymentStatusUpdate);

    return () => {
      paymentSocket.off("ticketTimeUpdated", onTicketTimeUpdated);
      paymentSocket.off("paymentStatusUpdate", onPaymentStatusUpdate);
    };
  }, [paymentSocket, paymentConnected, handleTicketExtended, location.pathname]);

  useEffect(() => {
    return () => {
      clearTicketExtendedTimer();
    };
  }, [clearTicketExtendedTimer]);

  return (
    <TicketExtendedModal
      show={showTicketExtendedModal}
      onHide={() => setShowTicketExtendedModal(false)}
    />
  );
};

export default KioskSessionManager;
